export const getAlerts = (state) => state.alert.alerts.result



// WEBPACK FOOTER //
// ./alert/selectors.js